"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = /*#__PURE__*/_react.default.createContext({
  scrollTo: function scrollTo() {
    return 0;
  },
  scrollToBottom: function scrollToBottom() {
    return 0;
  },
  scrollToEnd: function scrollToEnd() {
    return 0;
  },
  scrollToStart: function scrollToStart() {
    return 0;
  },
  scrollToTop: function scrollToTop() {
    return 0;
  }
});

context.displayName = 'ScrollToBottomFunctionContext';
var _default = context;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TY3JvbGxUb0JvdHRvbS9GdW5jdGlvbkNvbnRleHQuanMiXSwibmFtZXMiOlsiY29udGV4dCIsIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsInNjcm9sbFRvIiwic2Nyb2xsVG9Cb3R0b20iLCJzY3JvbGxUb0VuZCIsInNjcm9sbFRvU3RhcnQiLCJzY3JvbGxUb1RvcCIsImRpc3BsYXlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQSxJQUFNQSxPQUFPLGdCQUFHQyxlQUFNQyxhQUFOLENBQW9CO0FBQ2xDQyxFQUFBQSxRQUFRLEVBQUU7QUFBQSxXQUFNLENBQU47QUFBQSxHQUR3QjtBQUVsQ0MsRUFBQUEsY0FBYyxFQUFFO0FBQUEsV0FBTSxDQUFOO0FBQUEsR0FGa0I7QUFHbENDLEVBQUFBLFdBQVcsRUFBRTtBQUFBLFdBQU0sQ0FBTjtBQUFBLEdBSHFCO0FBSWxDQyxFQUFBQSxhQUFhLEVBQUU7QUFBQSxXQUFNLENBQU47QUFBQSxHQUptQjtBQUtsQ0MsRUFBQUEsV0FBVyxFQUFFO0FBQUEsV0FBTSxDQUFOO0FBQUE7QUFMcUIsQ0FBcEIsQ0FBaEI7O0FBUUFQLE9BQU8sQ0FBQ1EsV0FBUixHQUFzQiwrQkFBdEI7ZUFFZVIsTyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IGNvbnRleHQgPSBSZWFjdC5jcmVhdGVDb250ZXh0KHtcbiAgc2Nyb2xsVG86ICgpID0+IDAsXG4gIHNjcm9sbFRvQm90dG9tOiAoKSA9PiAwLFxuICBzY3JvbGxUb0VuZDogKCkgPT4gMCxcbiAgc2Nyb2xsVG9TdGFydDogKCkgPT4gMCxcbiAgc2Nyb2xsVG9Ub3A6ICgpID0+IDBcbn0pO1xuXG5jb250ZXh0LmRpc3BsYXlOYW1lID0gJ1Njcm9sbFRvQm90dG9tRnVuY3Rpb25Db250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgY29udGV4dDtcbiJdfQ==